<span bottom
      [class]="'bar-button'"
      [pTooltip]="buttonTitle|translate"
      (click)="op.toggle($event)">
    <i *ngIf="inProgressCount>0" [class]="'bar-button-ico fa-solid fa-timeline'" pBadge
       [value]="inProgressCount"></i>
    <i *ngIf="inProgressCount===0" [class]="'bar-button-ico fa-solid fa-timeline'"></i>
    <div class="bar-button-text">{{buttonTitle|translate}}</div>
  </span>
<p-overlayPanel #op [showCloseIcon]="true" [style.width]="'70vw'" [style.minWidth]="'70vw'" [style.maxWidth]="'70vw'"
                [dismissable]="true" [styleClass]="'top-overlay'">
  <ng-template pTemplate>
    <app-allocation-tasks-table class="allocation-tasks-button" [transPartKey]="transPartKey"
                            [visible]="op.overlayVisible"></app-allocation-tasks-table>
  </ng-template>
</p-overlayPanel>
